<!--  -->
<template>
  <div
    class="common-foot"
    v-if="!this.$root.$data.isApp&&!this.$root.miniprogram"
  >
    <div class="privacy">
      <span @click="openPravicy(1)">用户权限</span>
      <span @click="openPravicy(2)">隐私协议</span>
      <span
        v-show="showAboutUs"
        @click="openPravicy(3)"
      >联系我们</span>
      <span
        v-show="showAboutUs"
        @click="openPravicy(4)"
      >关于我们</span>
    </div>
    <div class="version">
      <p>开发者名称：爱启航在线考研软件&nbsp;&nbsp;版本号：{{ version }}</p>
    </div>
  </div>
</template>

<script>
import { reqAppVersion } from '@/api/home';

export default {
  data() {
    return {
      version: '',
      showAboutUs: false,
    };
  },
  mounted() {
    reqAppVersion().then((data) => {
      this.version = data.data[0].value;
    });
    if (this.$route.path === '/home') {
      this.showAboutUs = true;
    }
  },
  methods: {
    openPravicy(type) {
      let url = '';
      if (type === 1) {
        url = `${window.location.origin}/ark/user`;
      } else if (type === 3) {
        url = `${window.location.origin}/ark/contactUs`;
      } else if (type === 4) {
        url = `${window.location.origin}/ark/aboutUs`;
      } else {
        url = 'https://mobile.iqihang.com/zt/privacy_app/index.html';
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss">
.common-foot {
  position: absolute;
  bottom: 0;
  z-index: 100;
  width: 100%;
  height: 100px;
  padding: 10px 0 10px 0;
  background: #fff;
}
.privacy {
  display: flex;
  justify-content: center;
  padding: 10px 0 10px 0;
  span {
    padding: 0 10px;
    color: #333;
    font-size: 24px;
  }
  a {
    padding: 0 10px;
    color: #333;
    font-size: 24px;
  }
}
.version {
  p {
    color: #a5a5a5;
    font-size: 24px;
    text-align: center;
  }
}
</style>
